import { Col, Row } from "react-bootstrap";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { useEffect, useState } from "react";

const Overview = ({ data }) => {
  const [barOption, setBarOption] = useState({
    chart: {
      type: "bar",
      height: 200,
      plotBorderWidth: 1,
      plotBorderColor: "#E6E6E6",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [""],
      title: {
        text: null,
      },
      labels: {
        enabled: false,
        style: {
          color: "#97B6CF",
          fontSize: "10px",
          fontWeight: "400",
        },
      },
      gridLineWidth: 0,
      lineColor: "#E6E6E6",
    },
    yAxis: {
      title: {
        text: null,
      },
      tickAmount: 5,
      labels: {
        style: {
          color: "#97B6CF",
          fontSize: "10px",
          fontWeight: "400",
        },
        formatter: function () {
          const axis = this.axis;
          const max = axis.max;

          // If this is the last tick
          if (this.value === max) {
            return `<span style="white-space:nowrap;">Freq</span>`;
          }

          return this.value;
        },
      },
    },
    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      horizontalAlign: "center",
      width:"100%",
      layout: "horizontal",
      itemMarginTop: 5,
      itemMarginBottom: 5,
      itemDistance: 10, // gap between each legend item
      symbolPadding: 6, // gap between color dot and text (decrease this)
      symbolWidth: 10,
      symbolHeight: 10,
      symbolRadius: 5,
      itemStyle: {
        color: "#70899E",
        fontSize: "12px",
        fontWeight: "400",
      },
    },
    plotOptions: {
      series: {
        pointWidth: 28,
        borderWidth: 0,
        groupPadding: 1,
        dataLabels: {
          enabled: false,
        },
      },
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  });

  useEffect(() => {
    if (data && data.users?.length > 0) {
      const series = [
        {
          name: "Internal",
          color: "#0066BE",
          data: data.users[0]?.internal_users ? [data.users[0].internal_users] : [0],
        },
        {
          name: "External",
          color: "#C2E3FF",
          data: data.users[0]?.external_users ? [data.users[0].external_users] : [0],
        },
      ];
      setBarOption((prev) => ({
        ...prev,
        series: series,
      }));
    }
  }, [data]);

  return (
    <div className="profile-engagement vwd-overview">
      <div className="profile-engagement-block">
        <Row>
          <Col className="hcp-profile-view" id="box-1" data-printable="true">
            <div className="profile-title d-flex align-items-center justify-content-between">
              <p>VWD Journey Users</p>
            </div>
            <div className="hcp-profile-content live-events-graph d-flex">
              <div className="total-user-graph d-flex flex-column ">
                <div class="d-flex justify-content-between events-boxes-shadow vwd-totaluser-box">
                  <span className="label">Total Users |</span>
                  <span className="count">
                    {data &&
                    data.users?.length > 0 &&
                    data.users[0]?.total_users
                      ? data.users[0]?.total_users
                      : 0}
                  </span>
                </div>
                {data.users?.length > 0 ? (
                  <div className="users-bar-graph">
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={barOption}
                    />
                  </div>
                ) : (
                  <div className="no-data" style={{ height: "100%" }}>
                    No data available
                </div>
                )}
              </div>
              <div className="vwd-total-visit" id="box-3" data-printable="true">
                <div className="hcp-profile-content live-events-graph">
                  <div className="d-flex justify-content-between events-boxes-shadow vwd-totaluser-box">
                    <span className="label">Total VWD Journey visits |</span>
                    <span className="count">{data?.totalVisits || 0}</span>
                  </div>

                  <div className="vwd-inner-box">
                    <div className="visit-card octapharma">
                      <h5>Octapharma</h5>
                      <span className="visit-count">{data?.octaVisits}</span>

                      <div className="dashed-line"></div>

                      <p>
                        Ave. Session duration
                        <span>
                          {data?.avgOctaDuration} <small>min</small>
                        </span>
                      </p>
                    </div>

                    <div className="visit-card hcp">
                      <h5>HCP</h5>
                      <span className="visit-count">{data?.hcpVisits}</span>

                      <div className="dashed-line"></div>

                      <p>
                        Ave. Session duration
                        <span>
                          {data?.avgHcpDuration} <small>min</small>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Overview;
